import ProviderFormConfig from "./form";
import { ProviderFormData } from "@/formTypes/ProviderFormDataType";
import GenericForm from "../GenericForm";
import { ProviderApi, ProviderDataType } from "@/api/ProviderApi";

type ProviderFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const ProviderForm = (props: ProviderFormProps) => {

  return (
    <GenericForm<ProviderFormData, ProviderDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={ProviderFormConfig}
      getNextCode={() => ProviderApi.getNextCode("codigo")}
      getById={(...arg) => ProviderApi.get(...arg)}
      createFn={(...arg) => ProviderApi.create(...arg)}
      updateFn={(...arg) => ProviderApi.update(...arg)}
      successMessage="El provedor ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información del provedor"
    />
  )
}

export default ProviderForm;